var _ = require('underscore');
var Marionette = require('marionette');
var FilterType = EY.Consultation.Lookups.FilterType;


var Quicklink = Marionette.View.extend({
    events: {
        'click @ui.quicklink': 'select'
    },
    modelEvents: {
        'change:count': function () { this.ui.count.html(this.model.get('count')); },
        'change:selected': function () {
            this.model.get('selected') ? this.ui.quicklink.addClass('link-active') : this.ui.quicklink.removeClass('link-active');
        }
    },
    tagName: 'li',
    template: '#quicklink',
    ui: {
        count: '#count',
        quicklink: '#link'
    },
    select: function () {
        this.model.collection.any(function (model) { return model.get('selected') && model.set('selected', false); });
        this.model.set('selected', true);
    },
    onAttach:function(){
        if (this.model.get('id') !== 'PendingMyAction') {
            if (this.model.get('id') !== 'My-All') {
                this.ui.quicklink.addClass('visible-lg');
            }
        }
    }
});

var Quicklinks = Marionette.CollectionView.extend({
    className: 'nav nav-pills',
    childView: Quicklink,
    tagName: 'ul',
    filter: function (child) {
        return child.get('type') === FilterType.Quicklink;
    }
});

module.exports.show = function (options) {
    var quicklinks = options.queries;
    var region = options.region;

    region.show(new Quicklinks(_.extend({}, options, { collection: quicklinks })));
};


// WEBPACK FOOTER //
// ./js/Modules/Home/HomeQuicklinks.js